import type { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables/icons';
import { settingsLayoutComponents, settingsLayoutProps } from '~/pages/layout';
import { ROUTE_KEYS } from '~/router';

const GeneralRoute: RouteRecordRaw = {
	path: 'general',
	name: ROUTE_KEYS.SETTINGS_GENERAL,
	meta: {
		label: 'general.page-title',
		isSettingsNavEntry: true,
		icon: () => $i('building-memo'),
		auth: true
	},
	props: {
		...settingsLayoutProps
	},
	components: {
		default: () => import('./general.page.vue'),
		...settingsLayoutComponents
	}
};

export default GeneralRoute;
